









import { Component, Vue } from "vue-property-decorator";
import moduleHeader from "@/components/moduleHeader/header.vue";
@Component({
  name: "detailCom",
  components: {
    moduleHeader,
  },
})
export default class extends Vue {
  storyData = {};
  created() {
    const { url, name } = this.$route.query;
    this.storyData = {
      url,
      name,
    };
  }

  backup() {
    const { path } = this.$route.query as { path: string };
    this.$router.push(path);
  }
}
